import { init } from '@aimitojs/browser'
import config from '@/config/user.env.js'
import store from '@/store/index'

export const AiMitoInstance = init({
    appKey: config.monitorAppKey,
    serviceName: config.monitorServiceName,
    dsn: config.monitorDsn,
    backUserId() {
        // 比如userId为放在Cookies中的集团MIP账号
        return store.state.user.userCode || ''
    },
})
